<template>
  <modal :id="modalId">

    <template v-slot:header>
      <i class="fa fa-ban modal-icon"></i>
      <h4 class="modal-title">{{ title }}</h4>
    </template>

    <form :id="formId" :action="action" method="POST">

      <h3 class="text-center">Are you sure you would like to reject the transaction?</h3>

      <tpa-queue-item-notification
        class="mt-5 mb-0"
        :text-area-field-name="notificationFieldName"
        :selected-users-field-name="notificationUsersFieldName"
        :initial-text="notificationInitialText"
        :initial-users="notificationInitialUsers"
        :user-id="userId"
        :user-first-name="userFirstName"
        :user-last-name="userLastName">
      </tpa-queue-item-notification>

      <slot name="hidden"></slot>
      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>
      <button type="submit" name="button_reject" class="btn btn-danger" :form="formId">
        <i class="fa fa-fw fa-save"></i> Reject
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
import TpaQueueItemNotification from "../TpaQueueItemNotification.vue";

export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'rejectTpaQueueItemModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: "Reject Transaction"
    },

    // Transaction user ID.
    userId: {
      type: Number,
      default: 0
    },

    // Transaction user first name.
    userFirstName: {
      type: String,
      default: ""
    },

    // Transaction user last name.
    userLastName: {
      type: String,
      default: ""
    },

    // Notification initial text.
    notificationInitialText: {
      type: String,
      default: ""
    },

    // Notification initial users.
    notificationInitialUsers: {
      type: String,
      default: ""
    },

    // Notification field name.
    notificationFieldName: {
      type: String
    },

    // Selected users field name.
    notificationUsersFieldName: {
      type: String
    },

  },

  /**
   * Used components.
   */
  components: {TpaQueueItemNotification},

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    }

  },
}
</script>
